// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Pagination_buttons__A6xnq","button":"Pagination_button__3-_gC","current":"Pagination_current__2mmNj","disabled":"Pagination_disabled__3U69e"};